import React from 'react';
import { useTranslation } from 'react-i18next';

const PrivacyPolicyModal = ({ content, onSubmit, onClose }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="link-2-wrap">
        <div className="link-wrap">
          <div className="header">
            <div className="title">
              <div className="middle">{t('privacy_policy_title')}</div>
            </div>
          </div>
          <div className="content">
            <div
              className="text"
              dangerouslySetInnerHTML={{
                __html: `${t('privacy_policy_contents')}`,
              }}
            />
          </div>
          <div className="footer" onClick={() => onClose()}>
            <div className="link-2-close">
              <div className="middle">
                <div className="close">{t('close')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicyModal;
